import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useI18n } from '../i18n/LanguageContext';
import { Reveal } from '../components/Reveal';

const IMGS = [
  // 01 Textile design & originals — vibrant printed textile
  'https://images.unsplash.com/photo-1581079289196-67865ea83118?auto=format&fit=crop&w=1600&q=80',
  // 02 Rotary engraving — man beside green textile rotary machine
  'https://images.unsplash.com/photo-1584269613077-1e64a0ac2779?auto=format&fit=crop&w=1600&q=80',
  // 03 Flat engraving & inkjet — silk screen printing frame held to light
  'https://images.unsplash.com/photo-1456456496250-d5e7c0a9b44d?auto=format&fit=crop&w=1600&q=80',
  // 04 Color separation & repeats — pantone book color swatches
  'https://images.unsplash.com/photo-1642480532034-362360552ccb?auto=format&fit=crop&w=1600&q=80',
  // 05 Sampling, digital & 3D mapping — close-up patterned printing cylinder
  'https://images.unsplash.com/photo-1699662585180-8cd17dfa9195?auto=format&fit=crop&w=1600&q=80',
  // 06 Architectural & automotive glass — modern glass facade
  'https://images.unsplash.com/photo-1481026469463-66327c86e544?auto=format&fit=crop&w=1600&q=80',
  // 07 Consulting & quality control — technician hands inspecting print
  'https://images.unsplash.com/photo-1643216674491-33878507b402?auto=format&fit=crop&w=1600&q=80',
];

export default function Services() {
  const { t } = useI18n();
  return (
    <div data-testid="services-page">
      {/* Header */}
      <section className="container-x pt-24 md:pt-36 pb-20" data-testid="services-hero">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <Reveal className="md:col-span-8">
            <div className="kicker">{t.services.kicker}</div>
            <h1 className="display-1 mt-6 text-forest text-balance">{t.services.title}</h1>
          </Reveal>
          <Reveal delay={100} className="md:col-span-4">
            <p className="lead">{t.services.intro}</p>
          </Reveal>
        </div>
      </section>

      {/* Detailed alternating grid */}
      <section className="container-x pb-32">
        <div className="divide-y divide-forest/15 border-y border-forest/15">
          {t.services.items.map((item, i) => {
            const reverse = i % 2 === 1;
            return (
              <div key={i} className="py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
                <Reveal className={`md:col-span-6 ${reverse ? 'md:order-2' : ''}`}>
                  <div className="relative overflow-hidden group">
                    <img src={IMGS[i % IMGS.length]} alt={item.title} className="w-full h-[360px] md:h-[460px] object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
                  </div>
                </Reveal>
                <Reveal delay={120} className={`md:col-span-5 ${reverse ? 'md:order-1 md:col-start-1' : 'md:col-start-8'}`}>
                  <span className="label-num">{item.n}</span>
                  <h3 className="display-3 mt-4 text-forest">{item.title}</h3>
                  <p className="lead mt-6">{item.body}</p>
                  <Link to="/contacto" className="mt-8 inline-flex items-center gap-2 text-forest link-underline text-[12px] uppercase tracking-[0.22em]" data-testid={`service-${item.n}-cta`}>
                    {t.cta.requestInfo} <ArrowUpRight size={14} />
                  </Link>
                </Reveal>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA */}
      <section className="bg-forest text-sand">
        <div className="container-x py-20 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-8">
            <div className="kicker !text-rust">{t.home.finalCtaKicker}</div>
            <h2 className="display-2 mt-6 text-sand text-balance max-w-[22ch]">{t.home.finalCtaTitle}</h2>
          </div>
          <div className="md:col-span-4 flex md:justify-end">
            <Link to="/contacto" className="btn-primary !bg-rust hover:!bg-sand hover:!text-forest" data-testid="services-final-cta">
              {t.cta.contact} <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
